<div *ngIf="showContent" class="admin-details">
  <div [ngSwitch]="selectedItem?.type">
    <app-zone-details *ngSwitchCase="AdministrationItemType.Zone"
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (zoneCreated)="onZoneCreated($event)"
                              (zoneUpdated)="onZoneUpdated($event)"
                              (zoneDeleted)="onZoneDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-zone-details>
    <app-zone-device-details *ngSwitchCase="AdministrationItemType.ZoneDevice"
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (deviceCreated)="onDeviceCreated($event)"
                              (deviceUpdated)="onDeviceUpdated($event)"
                              (deviceDeleted)="onDeviceDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-zone-device-details>
    <app-tariff-details *ngSwitchCase="AdministrationItemType.Tariff"
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (tariffCreated)="onTariffCreated($event)"
                              (tariffUpdated)="onTariffUpdated($event)"
                              (tariffDeleted)="onTariffDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-tariff-details>
    <app-subscription-details *ngSwitchCase="AdministrationItemType.Subscription"
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (subscriptionCreated)="onSubscriptionCreated($event)"
                              (subscriptionUpdated)="onSubscriptionUpdated($event)"
                              (subscriptionDeleted)="onSubscriptionDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-subscription-details>
    <app-structural-entry-details *ngSwitchCase="AdministrationItemType.ConfigBasedStructuralElement"
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (entryCreated)="onStructuralEntryCreated($event)"
                              (entryUpdated)="onStructuralEntryUpdated($event)"
                              (entryDeleted)="onStructuralEntryDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-structural-entry-details>
    <div *ngSwitchDefault=""></div>
  </div>
</div>

